import { KeyValueModel } from "model/api";
import { EnumTipoPropagandaLocal } from "model/enums/enum-tipo-propaganda-local";

export const PropagandaLocalMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoPropagandaLocal.Ambos, "Ambos"),
    new KeyValueModel(EnumTipoPropagandaLocal.Pdv, "PDV"),
    new KeyValueModel(EnumTipoPropagandaLocal.Retaguarda, "Retaguarda"),
];